import { useEffect } from 'react';
import theme from 'config/theme';

export const useInitTelegramWebApp = () => {
  useEffect(() => {
    const webApp = Telegram.WebApp;
    webApp.ready();
    webApp.expand();
    webApp.disableVerticalSwipes();
    webApp.MainButton.hide();
    webApp.setBackgroundColor(theme.palette.background.default);
    webApp.setHeaderColor(theme.palette.background.default);
  }, []);
};
